import { schema } from 'normalizr';
import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';

export const eventsApi = apiResourceBuilder('emts/2.0/events');

export const eventsSchema = new schema.Entity(
  'events',
  {},
  { idAttribute: 'key' }
);

export default entityActionCreator({
  schema: eventsSchema,
  api: eventsApi,
});



// WEBPACK FOOTER //
// ./src/App/events/actions/events/index.js